import React from 'react';
import Button from './style';
import BackProps from './type';
import { Icon } from '@/presentation/components';

const Back = ({ onClick = () => {}, tabIndex = 0, dataTestid }: BackProps) => (
  <Button
    type="button"
    tabIndex={tabIndex}
    onClick={onClick}
    data-testid={dataTestid}
  >
    <Icon name="arrow-left" size={24} color="#FF385B" />
    <p>Atrás</p>
  </Button>
);

export default Back;
